export const DEFAULT_ALLOWED_FILE_SIZE_MB = 2